// PLEASE THINK TWICE BEFORE CHANGING THIS FILE
// Set webpack public path at runtime before any imports
// See: https://webpack.js.org/guides/public-path/#on-the-fly
// This MUST be a global assignment (not let/const/var) for webpack to use it
// @ts-ignore
// eslint-disable-next-line no-global-assign
// sonar-disable-next-line javascript:S2814
__webpack_public_path__ = window.webpackPublicPath // NOSONAR

document.addEventListener('DOMContentLoaded', () => {
  // this is the only `require` that should be in our app. Using `require` here
  // allows us to defer import resolution until after the DOMContentLoaded
  // event is fired.
  require('./render')
})